import { Observer, Scene } from '@babylonjs/core';

import RenderingStateTracker from './RenderingStateTracker';

class FPS {
  private scene: Scene | undefined;
  private onAfterRender?: Observer<Scene> | undefined;
  private renderingStateTracker: RenderingStateTracker = new RenderingStateTracker();

  private times = new Array<number>(60);
  private index = 0;
  private count = 0;
  private lastTime = performance.now();

  update() {
    const now = performance.now();
    const delta = now - this.lastTime;
    this.lastTime = now;

    this.times[this.index] = delta;
    this.index = (this.index + 1) % this.times.length;
    this.count = Math.min(this.count + 1, this.times.length);
  }

  reset(scene: Scene) {
    if (this.scene && this.onAfterRender) {
      this.scene.onAfterRenderObservable.remove(this.onAfterRender);
    }
    this.renderingStateTracker.initialize(scene);
    this.scene = scene;
    this.onAfterRender = this.scene.onAfterRenderObservable.add(() => {
      this.update();
    });
  }

  measure(): number {
    if (!this.scene || this.count === 0 || !this.renderingStateTracker.isRenderingAtFullSpeed()) {
      return -1;
    }

    if (this.count === 0) return 0;
    const total = this.times.slice(0, this.count).reduce((a, b) => a + b, 0);
    return Math.round((1000 * this.count / total) * 100) / 100;
  }

  clear() {
    if (this.scene && this.onAfterRender) {
      this.scene.onAfterRenderObservable.remove(this.onAfterRender);
      this.onAfterRender = undefined;
    }
    this.scene = undefined;
    this.renderingStateTracker.clear();
  }
}

export default new FPS();
